/* On My Hand storefront behaviour. Works alongside Dawn's global.js, cart.js and cart-drawer.js. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var OMH = window.omh || {};

  /* ---------- money ---------- */
  function fmtMoney(cents) {
    var f = OMH.moneyFormat || '€{{amount}}';
    function delim(n, prec, thou, dec) {
      var parts = (n / 100).toFixed(prec).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return whole + (parts[1] ? dec + parts[1] : '');
    }
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var v;
    switch (key) {
      case 'amount_no_decimals': v = delim(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = delim(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': v = delim(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': v = delim(cents, 2, "'", '.'); break;
      default: v = delim(cents, 2, ',', '.');
    }
    return f.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]*>/g, '');
  }

  /* ---------- mobile nav ---------- */
  var mnav = $('#mnav');
  function setNav(open) {
    if (!mnav) return;
    mnav.classList.toggle('open', open);
    mnav.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('mnav-open', open);
    $$('[data-mnav-open]').forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
    if (open) { var x = $('[data-mnav-close]', mnav); if (x) x.focus(); }
  }

  /* ---------- search overlay ---------- */
  var os = $('#osearch');
  function setSearch(open) {
    if (!os) return;
    os.classList.toggle('open', open);
    if (open) { setTimeout(function () { var i = $('input[type=search]', os); if (i) i.focus(); }, 30); }
  }

  /* ---------- info drawers ---------- */
  var dr = $('#dr');
  var lastFocus = null;
  function openDrawer(k) {
    if (!dr) return;
    var panel = $('[data-dr="' + k + '"]', dr);
    if (!panel) return;
    lastFocus = document.activeElement;
    $$('[data-dr]', dr).forEach(function (p) { p.hidden = p !== panel; });
    $('#drh').textContent = panel.getAttribute('data-title');
    dr.classList.add('open');
    dr.setAttribute('aria-hidden', 'false');
    var x = $('.x', dr); if (x) x.focus();
  }
  function closeDrawer() {
    if (!dr || !dr.classList.contains('open')) return;
    dr.classList.remove('open');
    dr.setAttribute('aria-hidden', 'true');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-mnav-open]')) { setNav(true); return; }
    if (t.closest('[data-mnav-close]')) { setNav(false); return; }
    if (t.closest('[data-search-open]')) { e.preventDefault(); setSearch(true); return; }
    if (t.closest('[data-search-close]')) { setSearch(false); return; }
    if (t.closest('[data-close]')) { closeDrawer(); return; }
    var d = t.closest('[data-drawer]');
    if (d) { e.preventDefault(); openDrawer(d.getAttribute('data-drawer')); return; }
    var r = t.closest('[data-rail]');
    if (r) {
      var box = r.closest('.inner').querySelector('[data-railbox]');
      if (box) box.scrollBy({ left: (box.clientWidth / 2) * Number(r.getAttribute('data-rail')), behavior: 'smooth' });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); setNav(false); setSearch(false); }
  });

  /* localisation select */
  $$('select[data-autosubmit]').forEach(function (s) {
    s.addEventListener('change', function () { s.form.submit(); });
  });

  /* collection sort */
  $$('select[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', s.value);
      u.searchParams.delete('page');
      location.href = u.toString();
    });
  });

  /* ---------- videos ---------- */
  function startVideo(v) {
    if (!v.getAttribute('src') && v.dataset.src) v.src = v.dataset.src;
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  function heroVideos() {
    $$('.hero video').forEach(function (v) {
      if (v.offsetParent !== null || getComputedStyle(v).display !== 'none') startVideo(v);
      else if (!v.paused) v.pause();
    });
  }
  heroVideos();
  if (window.matchMedia) {
    var mq = window.matchMedia('(max-width:820px)');
    if (mq.addEventListener) mq.addEventListener('change', heroVideos);
  }
  var lazy = $$('video[data-lazyvid]');
  if (lazy.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) startVideo(en.target);
          else if (en.target.getAttribute('src')) en.target.pause();
        });
      }, { rootMargin: '300px 0px' });
      lazy.forEach(function (v) { io.observe(v); });
    } else lazy.forEach(startVideo);
  }
  if (window.matchMedia && window.matchMedia('(hover:hover)').matches) {
    document.addEventListener('mouseover', function (e) {
      var c = e.target.closest && e.target.closest('.pcard');
      if (!c) return;
      var v = $('video[data-hovervid]', c);
      if (v && v.paused) startVideo(v);
    });
    document.addEventListener('mouseout', function (e) {
      var c = e.target.closest && e.target.closest('.pcard');
      if (!c || (e.relatedTarget && c.contains(e.relatedTarget))) return;
      var v = $('video[data-hovervid]', c);
      if (v && !v.paused) v.pause();
    });
  }

  /* ---------- gallery dots ---------- */
  $$('[data-gal]').forEach(function (g) {
    var dots = g.parentNode.querySelector('[data-dots]');
    if (!dots) return;
    var items = $$('i', dots);
    g.addEventListener('scroll', function () {
      var w = g.firstElementChild ? g.firstElementChild.offsetWidth + 4 : 1;
      var i = Math.round(g.scrollLeft / w);
      items.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    }, { passive: true });
  });

  /* ---------- product form ---------- */
  var buy = $('[data-buy]');
  if (!buy) return;
  var form = $('[data-omh-form]', buy) || $('form[action*="/cart/add"]', buy);
  var vidInput = $('[data-vid]', buy);
  var atb = $('[data-atb]', buy);
  var priceEl = $('[data-price]', buy);
  var warn = $('[data-sizewarn]', buy);
  var ferr = $('[data-ferr]', buy);
  var groups = $$('.sizes[data-opt]', buy);
  var sectionId = buy.getAttribute('data-section');
  var productUrl = buy.getAttribute('data-product-url');
  var vmap = {};
  try {
    var vj = document.querySelector('script[data-variants="' + sectionId + '"]');
    if (vj) vmap = JSON.parse(vj.textContent);
  } catch (err) { vmap = {}; }
  var base = Number(atb ? atb.getAttribute('data-base') : 0) || 0;
  var available = true;
  var dateInCart = false;
  var boxCb = $('[data-addon="box"]', buy);
  var dateCb = $('[data-addon="date"]', buy);
  var dateHint = $('[data-date-hint]', buy);
  var resolving = null;

  function selected() {
    return groups.map(function (g) {
      var b = $('button[aria-pressed="true"]', g);
      return b ? b : null;
    });
  }
  function updateButton() {
    if (!atb) return;
    if (!available) { atb.disabled = true; atb.textContent = 'Sold out'; return; }
    atb.disabled = false;
    var t = base;
    if (boxCb && boxCb.checked) t += OMH.addons.box.price;
    if (dateCb && dateCb.checked && !dateInCart) t += OMH.addons.date.price;
    atb.textContent = 'Add to bag · ' + fmtMoney(t);
    $$('.addon label', buy).forEach(function (l) {
      var cb = $('input', l); l.classList.toggle('on', !!(cb && cb.checked));
    });
  }
  function applyVariant(v) {
    if (!v) { vidInput.value = ''; return; }
    vidInput.value = v.id;
    available = !!v.available;
    base = v.price;
    if (priceEl) priceEl.textContent = fmtMoney(v.price);
    try {
      var u = new URL(location.href); u.searchParams.set('variant', v.id);
      history.replaceState(history.state, '', u.toString());
    } catch (e) {}
    updateButton();
  }
  function resolveVariant() {
    var sel = selected();
    if (sel.some(function (b) { return !b; })) { vidInput.value = ''; return Promise.resolve(null); }
    if (warn) warn.hidden = true;
    var key = sel.map(function (b) { return b.getAttribute('data-val'); }).join('|');
    if (vmap[key]) { applyVariant(vmap[key]); return Promise.resolve(vmap[key]); }
    var ids = sel.map(function (b) { return b.getAttribute('data-ovid'); }).join(',');
    vidInput.value = '';
    resolving = fetch(productUrl + '?option_values=' + ids + '&section_id=omh-variant-json')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var s = doc.querySelector('script[type="application/json"]');
        var v = s ? JSON.parse(s.textContent) : null;
        if (v && v.options && v.options.join('|') !== key) v = null;
        if (v) { vmap[key] = v; applyVariant(v); }
        resolving = null;
        return v;
      })
      .catch(function () { resolving = null; return null; });
    return resolving;
  }
  groups.forEach(function (g) {
    g.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      $$('button', g).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      b.setAttribute('aria-pressed', 'true');
      resolveVariant();
    });
  });
  if (groups.length) resolveVariant();

  [boxCb, dateCb].forEach(function (cb) { if (cb) cb.addEventListener('change', updateButton); });
  if (dateCb) dateCb.addEventListener('change', function () {
    if (dateCb.checked || !dateInCart) return;
    dateCb.disabled = true;
    var drawer = document.querySelector('cart-drawer');
    var secs = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender() : [];
    var payload = { id: String(OMH.addons.date.id), quantity: 0 };
    if (secs.length) { payload.sections = secs.map(function (x) { return x.id; }); payload.sections_url = location.pathname; }
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        markDateInCart(false); dateCb.checked = false; updateButton();
        if (cart.sections) secs.forEach(function (x) {
          var html = cart.sections[x.id]; if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var sel = x.selector || ('#shopify-section-' + x.id);
          var src = doc.querySelector(sel) || doc.querySelector('#shopify-section-' + x.id);
          var dst = document.querySelector(sel) || document.getElementById(x.id);
          if (src && dst) dst.innerHTML = src.innerHTML;
        });
        try { if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'omh-product', cartData: cart }); } catch (e) {}
      })
      .catch(function () { dateCb.checked = true; dateCb.disabled = false; });
  });

  function markDateInCart(inCart) {
    dateInCart = inCart;
    if (!dateCb) return;
    if (inCart) {
      dateCb.checked = true; dateCb.disabled = false;
      if (dateHint) dateHint.textContent = 'Already in your bag. One date covers every ring in this order, including this one. Untick to remove it.';
    } else {
      dateCb.disabled = false;
      if (dateHint) dateHint.textContent = 'The real date your ring was made, cut inside the band. One date covers every ring in the order.';
    }
    updateButton();
  }
  function syncCart() {
    if (!dateCb) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var has = cart.items.some(function (i) { return i.variant_id === OMH.addons.date.id; });
      markDateInCart(has);
    }).catch(function () {});
  }
  syncCart();
  if (window.subscribe && window.PUB_SUB_EVENTS) {
    try { subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) { if (!ev || ev.source !== 'omh-product') syncCart(); }); } catch (e) {}
  }

  /* delivery estimate: 10 making days + 5 to 7 in transit (business days) */
  var eta = $('[data-eta]', buy);
  if (eta) {
    var d = new Date(), k = 0;
    var opt = { day: 'numeric', month: 'long' };
    while (k < 15) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) k++; }
    var a = d.toLocaleDateString('en-GB', opt);
    k = 0;
    while (k < 2) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) k++; }
    var b = d.toLocaleDateString('en-GB', opt);
    eta.innerHTML = 'Order today, delivered to the EU or UK between <b>' + a + '</b> and <b>' + b + '</b>.';
  }

  function showError(msg) {
    if (!ferr) return;
    ferr.textContent = msg || 'Something went wrong. Please try again.';
    ferr.hidden = false;
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (ferr) ferr.hidden = true;
      var go = function () {
        var vid = Number(vidInput.value);
        if (!vid) {
          if (warn) warn.hidden = false;
          var need = groups.filter(function (g) { return !$('button[aria-pressed="true"]', g); })[0] || groups[0];
          if (need) {
            need.classList.remove('need'); void need.offsetWidth; need.classList.add('need');
            need.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return;
        }
        var items = [{ id: vid, quantity: 1 }];
        var addBox = boxCb && boxCb.checked;
        var addDate = dateCb && dateCb.checked && !dateInCart;
        if (addBox) items.push({ id: OMH.addons.box.id, quantity: 1 });
        if (addDate) items.push({ id: OMH.addons.date.id, quantity: 1 });
        var drawer = document.querySelector('cart-drawer');
        var body = { items: items };
        if (drawer) {
          body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = location.pathname;
          if (drawer.setActiveElement) drawer.setActiveElement(atb);
        }
        atb.classList.add('loading'); atb.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) { showError(res.description || res.message); return; }
            if (window.publish && window.PUB_SUB_EVENTS) {
              try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'omh-product', productVariantId: vid, cartData: res }); } catch (err) {}
            }
            if (addBox) boxCb.checked = false;
            if (addDate) markDateInCart(true);
            if (drawer && res.sections) {
              res.id = vid;
              drawer.renderContents(res);
            } else {
              location.href = '/cart';
            }
          })
          .catch(function () { showError(); })
          .finally(function () { atb.classList.remove('loading'); atb.disabled = !available; updateButton(); });
      };
      if (resolving) resolving.then(go); else go();
    });
  }
  updateButton();
})();
